<script>
import resources from './resources'

export default {
  name: 'my-address',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xl-4.col-lg-6.col-md-6.col-sm-12
    .card
      .header
        h2
          strong {{ pet.name }}
        ul.header-dropdown
          li.dropdown(:class="{'show': actions}")
            a.dropdown-toggle(
              href='javascript:void(0);',
               data-toggle='dropdown',
               role='button',
               aria-haspopup='true',
               aria-expanded='false'
               @click.prevent="viewActions(actions)"
            )
              i.zmdi.zmdi-more
            ul.dropdown-menu.dropdown-menu-righ(
              x-placement='bottom-end',
              style='position: absolute; transform: translate3d(-128px, 32px, 0px); top: 0px; left: 0px; will-change: transform;'
              :class="{'show': actions}"
            )
              //-li
                router-link.cursor-pointer(:to="{name: 'dweller.car.edit', params: {id: car.id, tower_id: car.unit_id, tower_id: car.unit_id_id}}") Editar
              li
                 a(href='javascript:void(0);', @click.prevent="$emit('on-delete', pet)") Excluir
      .body
        h6.m-b-15
        .row
          .col-4
            small
              strong Torre:
          .col-8
            small
              strong {{ pet.tower.name }}
        .row
          .col-4
            small
              strong Unidade:
          .col-8
            small
              strong {{ pet.unit.number }}
        .row
          .col-4
            small
              strong Raça:
          .col-8
            small
              strong {{ pet.breed }}
        .row
          .col-4
            small
              strong Cor:
          .col-8
            small
              strong {{ pet.color }}

</template>
<style scoped>
  .team-info {
      width: 42px;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      -ms-border-radius: 50%;
      border-radius: 50%;
      border: 2px solid #fff;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
      margin-top: 0px;
  }
  .online {
    margin-left: 10px;
    color: #86BB71;
  }
  .offline {
    margin-left: 10px;
    color: #E38968;
  }
  .online, .offline, .me {
      margin-right: 3px;
      font-size: 10px;
  }
  .material-icons {
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 12px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/dweller/pets/index/components/item.vue